/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOrganizationProperties200ResponseMeta
 */
export interface GetOrganizationProperties200ResponseMeta {
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationProperties200ResponseMeta
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationProperties200ResponseMeta
     */
    offset?: number;
}

/**
 * Check if a given object implements the GetOrganizationProperties200ResponseMeta interface.
 */
export function instanceOfGetOrganizationProperties200ResponseMeta(value: object): value is GetOrganizationProperties200ResponseMeta {
    return true;
}

export function GetOrganizationProperties200ResponseMetaFromJSON(json: any): GetOrganizationProperties200ResponseMeta {
    return GetOrganizationProperties200ResponseMetaFromJSONTyped(json, false);
}

export function GetOrganizationProperties200ResponseMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationProperties200ResponseMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'limit': json['limit'] == null ? undefined : json['limit'],
        'offset': json['offset'] == null ? undefined : json['offset'],
    };
}

export function GetOrganizationProperties200ResponseMetaToJSON(json: any): GetOrganizationProperties200ResponseMeta {
    return GetOrganizationProperties200ResponseMetaToJSONTyped(json, false);
}

export function GetOrganizationProperties200ResponseMetaToJSONTyped(value?: GetOrganizationProperties200ResponseMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'limit': value['limit'],
        'offset': value['offset'],
    };
}

